import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

export default class NavbarLink extends Component {

  render() {

    if (this.props.onClick) {
      return (
        <div className={'navbar-link' + (this.props.active ? ' navbar-active' : '')} onClick={this.props.onClick}>
          {this.props.title}
        </div>
      );
    }
    return (
      <Link className={'navbar-link' + (this.props.active ? ' navbar-active' : '')} to={this.props.route} onClick={this.props.onClick}>
        {this.props.title}
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarLink/index.js